/*
 * The pledge, priced for where the visitor is.
 *
 * India pays ₹2,000; everywhere else pays $99. One number, decided once, read by the homepage,
 * the Commitment page and the waitlist — so the three can never disagree the way ₹2,000 and ₹100
 * used to.
 *
 * ponytail: the region comes from the browser's own IANA time zone, not from a geo-IP lookup.
 * A lookup means a third-party request on the critical path of the landing page's first paint,
 * an API key, a rate limit, and a failure mode where the price is wrong or missing while the
 * request is in flight. The time zone is already in the browser, costs nothing, cannot fail, and
 * is set by the device the person is actually holding — a traveller's laptop still says
 * Asia/Kolkata. Upgrade path if true IP is ever required: add `GET /api/geo` on the backend,
 * read the country from the proxy header, and have `regionOf()` prefer that when it resolves.
 */

// Both spellings are live: Asia/Calcutta is the older name and is still what several browsers
// and most of Windows report.
const IN_ZONES = new Set(["Asia/Kolkata", "Asia/Calcutta"]);

export function regionOf() {
  try {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (IN_ZONES.has(zone)) return "IN";
    // A device with the time zone withheld (some hardened browsers) still exposes a locale.
    if (!zone && /-IN$/i.test(navigator.language || "")) return "IN";
  } catch {
    /* Intl missing or throwing — fall through to the default. */
  }
  return "INTL";
}

const PLANS = {
  IN: { amount: 2000, currency: "INR", symbol: "₹", locale: "en-IN" },
  INTL: { amount: 99, currency: "USD", symbol: "$", locale: "en-US" },
};

export const PLEDGE = PLANS[regionOf()];

/*
 * Grouped thousands ALWAYS, minor units only when there are any — otherwise a balance of 1933.33
 * reads as "₹1933.33" directly beside "₹2,000".
 */
export function money(n, plan = PLEDGE) {
  const r = Math.round(n * 100) / 100;
  const decimals = Number.isInteger(r) ? 0 : 2;
  return plan.symbol + r.toLocaleString(plan.locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

// 12% of the pledge, returned on completion. Rounded to a whole unit so the promise is a clean
// number in both currencies.
export const INTEREST = Math.round(PLEDGE.amount * 0.12);
export const RETURN_AMOUNT = PLEDGE.amount + INTEREST;
